import { invalidateAPITags } from "utils/common";
import { schoolClientsApi } from "./school.client";
import { homeEducationApi } from "./homeEducation.client";
import { privateClientApi } from "./private.client";
import { clientChatterApi } from "./chatter.client";

// Each client list lives in its own createApi slice, so a bulk action has to invalidate the
// matching one. Invalidating the list tag rather than refetching the active query matters
// because the list is cached per filter set: changing a client's status while filtered to
// "inactive" must also drop the cached "active" page, which refetch() would leave stale.
const CLIENT_LIST_APIS = {
    "school": { api: schoolClientsApi, tags: ["SchoolClients"] },
    "home-education": { api: homeEducationApi, tags: ["HomeEducationList"] },
    "private": { api: privateClientApi, tags: ["PrivatClientApi"] },
    "chatter": { api: clientChatterApi, tags: ["ClientChatterApi"] },
};

export const invalidateClientList = (queryFulfilled, dispatch, clientType) => {
    const entry = CLIENT_LIST_APIS[clientType];
    if (!entry) return;
    return invalidateAPITags(queryFulfilled, dispatch, entry.api, entry.tags);
};

export default CLIENT_LIST_APIS;
